module Shared.LogIn

open Illy.SafeStack
open Illy.SafeStack.Validation

type EnteredCredentials =
    {
        Username: string
        Password: string
    }

type Credentials = Entered of EnteredCredentials | AD of string

[<RequireQualifiedAccess>]
type MFAMode =
    | Email of recheck: bool
    | App of (string*string) option

module Validations = 
    open Illy.SafeStack.SharedValidations
    open Illy.SafeStack.CompositionalValidation
    open Shared.Validations.Password

    type LogInValidations =
        | Username of StringValidations
        | Password of PasswordValidations
        | GeneralError of string
        | Timeout of int

    module LogInValidations =
        let toString =
            function
            | LogInValidations.Username x -> x.toString()
            | LogInValidations.Password x -> PasswordValidations.toString x
            | LogInValidations.GeneralError x -> x
            | Timeout i -> i.ToString()

    let validateUsername username =
        validate {
            return! validateString 250 true username
        }

    let validateCredentials username password = 
        validate {
            return! (validateUsername >-> Username) username
            return! (validatePassword >-> Password) password
        }

type LoginResult =
    | Successful of ClientSideUser
    | PasswordExpired
    | MFARequired of MFAMode * ClientSideUser
    | LoginFailure of ValidationResult<Validations.LogInValidations, Validation.NoWarning>
